module.exports = __webpack_public_path__ + "img/logo-dark.61a3c299.png";